import * as React from "react";
import { Modal, Box, SpaceBetween, Button } from "@amzn/awsui-components-console";
import { DUPLICATE_MODAL_TITLE } from "../../app/constants";
import { MetricsPublisher } from "../../metrics";
import { useAppSelector } from "src/redux/hooks";
import { RootState } from "../../redux/store";

interface setModalProps {
  setModalOpen: any;
  onResetForm: any;
  onCancel?: any;
  isModalOpen: boolean;
  modalTitle: string;
  modalDescription: React.ReactNode;
  cancelButtonText: string;
  confirmButtonText: string;
}

const ResetFormModal = ({
  setModalOpen,
  isModalOpen,
  modalTitle,
  onResetForm,
  onCancel,
  modalDescription,
  cancelButtonText,
  confirmButtonText,
}: setModalProps) => {
  const { user } = useAppSelector((state: RootState) => state.auth);
  const resetForm = () => {
    if (modalTitle === DUPLICATE_MODAL_TITLE) {
      const metricsPublisher = new MetricsPublisher("duplicateClaimReset");
      metricsPublisher.publishDuplicateClaimWarningResultsMetrics(user.id);
    }
    onResetForm();
    setModalOpen(false);
  };
  const cancelModal = () => {
    if (modalTitle === DUPLICATE_MODAL_TITLE) {
      const metricsPublisher = new MetricsPublisher("duplicateClaimIgnored");
      metricsPublisher.publishDuplicateClaimWarningResultsMetrics(user.id);
    }
    if (onCancel) {
      onCancel();
    } else {
      setModalOpen(false);
    }
  };

  const handleDismiss = () => {
    // For claim retrieval error modal, treat dismiss (X button) same as cancel
    if (onCancel) {
      onCancel();
    } else {
      setModalOpen(false);
    }
  };

  return (
    <Modal
      onDismiss={handleDismiss}
      visible={isModalOpen}
      closeAriaLabel="Close modal"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={() => cancelModal()} data-testid="modal-cancel-button">
              {cancelButtonText}
            </Button>
            <Button variant="primary" onClick={resetForm} data-testid="modal-confirmation-button">
              {confirmButtonText}
            </Button>
          </SpaceBetween>
        </Box>
      }
      header={modalTitle}
    >
      {modalDescription}
    </Modal>
  );
};
export default ResetFormModal;
